// Pure status derivation for the Push & Sign modal rows. CommonJS so Jest can
// require it directly (same pattern as assessment-risk.js); imported by
// push-modal.jsx for the row status display.
//
// The key distinction this captures: pushAndSignForPatient treats a sign
// failure as non-fatal and returns { ok:true, results:{ billingPushed:true,
// signed:false }, errors:['sign: ...'] }. The bill is in Elation but the note
// is unsigned in the inbox — that must NOT render as a plain "Done ✓", or the
// clinician closes the modal and the draft is never signed.

function deriveRowStatus(res) {
  if (!res || typeof res !== 'object') return { status: 'failed', error: 'no result' };

  // Ineligible / no-op — reported by the push pipeline as ok:true + skipped.
  if (res.skipped) return { status: 'skipped', error: res.reason || '' };

  if (res.ok) {
    const r = res.results || {};
    // Pushed to Elation but signing didn't complete.
    if (r.billingPushed && r.signed === false) {
      const errs = Array.isArray(res.errors) ? res.errors : [];
      const signErr = errs.find((e) => /^sign:/i.test(String(e)));
      return { status: 'pushed_unsigned', error: signErr || 'pushed — sign in Elation' };
    }
    return { status: 'done' };
  }

  const errs = Array.isArray(res.errors) ? res.errors : [];
  return { status: 'failed', error: errs.join('; ') || 'unknown error' };
}

module.exports = { deriveRowStatus };
